import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	title: {
		id: 'nudge-bundled-users-to-join-connie.title',
		defaultMessage: 'Your team is working in Confluence',
		description: 'Flag header that suggests the user join their teammates in Confluence.',
	},
	description: {
		id: 'nudge-bundled-users-to-join-connie.description',
		defaultMessage: 'Don’t miss out on the conversations happening between your collaborators!',
		description: 'Flag description suggesting the user to use Confluence.',
	},
	joinButton: {
		id: 'nudge-bundled-users-to-join-connie.join-button',
		defaultMessage: 'Access Confluence for free',
		description: 'Button to navigate to Confluence.',
	},
});
